require('../brokerTransferValuesStep.scss');
require('./brokerTransferValuesStep2.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
// @ helpers
const { FormattedText, formatText } = require('core/i18n').i18n;
// @ components
const { LoadingSection } = require('commonsComponents/loadingSection');
const BrokerTransferValuesTable = require('./brokerTransferValuesTable/brokerTransferValuesTable');
const { RadioButton } = require('commonsComponents/radioButton');
const { RadioButtonGroup } = require('commonsComponents/radioButtonGroup');
// @ consntans
const {
    BROKER_TRANSFER_VALUES_TYPE_TOTAL,
    BROKER_TRANSFER_VALUES_TYPE_PARTIAL } = require('constants/index');

class BrokerTransferValuesStep2 extends React.Component {
    constructor(props) {
        super(props);

        this.buildTypeBlock = this.buildTypeBlock.bind(this);
        this.handleTypeChange = this.handleTypeChange.bind(this);
    }

    componentDidMount() {
        const { immTransferValues, getContractValues } = this.props;

        const contractFrom = immTransferValues.getIn(['steps', 0, 'accountIdFrom']);
        const immContractFrom = immTransferValues.getIn(['steps', 0, 'accountsFromOptions', contractFrom]);

        getContractValues(immContractFrom);
    }

    buildTypeBlock() {
        const { immTransferValues } = this.props;
        let selected;

        if ( immTransferValues.getIn(['steps', 1, BROKER_TRANSFER_VALUES_TYPE_TOTAL, 'selected']) ) {
            selected = BROKER_TRANSFER_VALUES_TYPE_TOTAL;
        }

        if ( immTransferValues.getIn(['steps', 1, BROKER_TRANSFER_VALUES_TYPE_PARTIAL, 'selected']) ) {
            selected = BROKER_TRANSFER_VALUES_TYPE_PARTIAL;
        }

        const errorState = !immTransferValues.getIn(['steps', 1, 'valid']);
        let errorElement;
        const errorMsg = immTransferValues.getIn(['steps', 1, 'partial', 'id'])
            ? "broker-transferValuesStep2ErrorTitles"
            : "broker-transferValuesStep2ErrorOption";

        if (errorState) {
            errorElement = (
                <div className="broker-transfer-values-step-two__error-message">
                    <FormattedText value={errorMsg} />
                </div>
            );
        }

        return (
            <div className="broker-transfer-values-step-two__transfer-type">
                <RadioButtonGroup
                    name="transferValuesType"
                    idPrefix="cancelChequebookMotiveRadio"
                    selectedValue={selected}
                    onChange={this.handleTypeChange}
                    isHorizontal={true}
                >
                    <RadioButton
                        label={formatText(`broker-transferValuesSidebarSecondStepTransferType${BROKER_TRANSFER_VALUES_TYPE_TOTAL}`)}
                        value={BROKER_TRANSFER_VALUES_TYPE_TOTAL}
                    />
                    <RadioButton
                        label={formatText(`broker-transferValuesSidebarSecondStepTransferType${BROKER_TRANSFER_VALUES_TYPE_PARTIAL}`)}
                        value={BROKER_TRANSFER_VALUES_TYPE_PARTIAL}
                    />
                </RadioButtonGroup>

                {errorElement}
            </div>
        );
    }

    handleTypeChange(value) {
        this.props.setType(value);
    }

    render() {
        const { immTransferValues, immContractValues } = this.props;
        const contractFrom = immTransferValues.getIn(['steps', 0, 'accountIdFrom']);
        const contractTo = immTransferValues.getIn(['steps', 0, 'accountIdTo']);
        let valuesBlock, typeBlock;

        if (contractFrom !== null && contractFrom !== undefined && contractTo !== null && contractTo !== undefined) {
            const immContractFrom = immTransferValues.getIn(['steps', 0, 'accountsFromOptions', contractFrom]);
            const contractFromId = immContractFrom.get('walletNumber');
            const isSuccessful = immContractValues.getIn([contractFromId, 'success']);
            const areValuesLoading = immContractValues.size === 0 || immContractValues.getIn([contractFromId, 'isFetching']);
            typeBlock = this.buildTypeBlock();

            if (areValuesLoading) {
                valuesBlock = <LoadingSection />;
            } else if (isSuccessful) {
                valuesBlock = (
                    <section className="broker-transfer-values-step-two__values">
                        <header className="broker-transfer-values-step-two__values-header">
                            <FormattedText value="broker-transferValuesStep2ValuesTitle" />
                        </header>
                        <BrokerTransferValuesTable
                            contractId={contractFromId}
                            immContractValues={immContractValues}
                            immTransferValues={immTransferValues}
                        />
                    </section>
                );
            }
        }

        return (
            <article className="broker-transfer-values-step">
                <header className="broker-transfer-values-step__header">
                    <FormattedText value="broker-transferValuesStep2Title" className="broker-transfer-values-step__title" />
                </header>
                <section className="broker-transfer-values-step__content">
                    <p>
                        <FormattedText value="broker-transferValuesStep2Message" />
                    </p>
                    {typeBlock}
                    {valuesBlock}
                </section>
            </article>
        )
    }
}

BrokerTransferValuesStep2.propTypes = {
    immStocksContracts: PropTypes.object.isRequired,
    immTransferValues: PropTypes.object.isRequired,
    immContractValues: PropTypes.object.isRequired,
    getContractValues: PropTypes.func.isRequired,
    setType: PropTypes.func.isRequired
}

module.exports = BrokerTransferValuesStep2;
